import { __decorate, __metadata } from 'tslib';
import { SpeNAccountFavoriteProxy, UiPxAccountPaymentFavoriteModule } from '@wlp/ui-px-account-payment-favorite';
import { DocumentValidator, ErrorMessageService, UfService } from '@wlp/ui-bs-util';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { Injectable, NgModule } from '@angular/core';
import { SpeNOpenAccountProxy } from '@wlp/ui-px-cashout';

class AccountPaymentFavoriteDTO {
}

var DeletedEnum;
(function (DeletedEnum) {
    DeletedEnum["FALSE"] = "0";
    DeletedEnum["TRUE"] = "1";
})(DeletedEnum || (DeletedEnum = {}));

var TypeEnum;
(function (TypeEnum) {
    TypeEnum["ON_US"] = "ON_US";
    TypeEnum["TED"] = "TED";
    TypeEnum["BILLET"] = "BILLET";
    TypeEnum["PIX"] = "PIX";
    TypeEnum["TEF"] = "TEF";
})(TypeEnum || (TypeEnum = {}));

let AccountPaymentFavoriteService = class AccountPaymentFavoriteService {
    constructor(formBuilder, favoriteService, speNOpenAccountProxy, errorMessageService, ufService) {
        this.formBuilder = formBuilder;
        this.favoriteService = favoriteService;
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.errorMessageService = errorMessageService;
        this.ufService = ufService;
        this.errorMessages = {
            document: [
                {
                    type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.DOCUMENT.MESSAGE.REQUIRED'
                },
                {
                    type: 'cnpjNotValid',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.DOCUMENT.MESSAGE.CNPJ_NOT_VALID'
                },
                {
                    type: 'cpfNotValid',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.DOCUMENT.MESSAGE.CPF_NOT_VALID'
                }
            ],
            name: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.NAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.NAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.NAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 60 }
                },
            ],
            email: [
                {
                    type: 'required',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.EMAIL.MESSAGE.REQUIRED',
                },
                {
                    type: 'minlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.EMAIL.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.EMAIL.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 },
                },
                { type: 'pattern', message: 'FAVORITES.EDIT_FAVORITE.FORM.EMAIL.MESSAGE.PATTERN' },
            ],
            accountType: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.ACCOUNT_TYPE.MESSAGE.REQUIRED' },
            ],
            bank: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.BANK.MESSAGE.REQUIRED' },
            ],
            branch: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.BRANCH.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.BRANCH.MESSAGE.MIN_LENGTH',
                    param: { minLength: 4 }
                },
                {
                    type: 'maxlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.BRANCH.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 4 }
                },
            ],
            accountNumber: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.ACCOUNT_NUMBER.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.ACCOUNT_NUMBER.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 15 }
                },
            ],
            pixKey: [
                {
                    type: 'required',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.PIX_KEY.MESSAGE.REQUIRED',
                },
                {
                    type: 'minlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.PIX_KEY.MESSAGE.MIN_LENGTH',
                    param: { minLength: 9 },
                },
                {
                    type: 'maxlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.PIX_KEY.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 },
                },
            ],
            typeKey: [
                {
                    type: 'required',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.TYPE_KEY.MESSAGE.REQUIRED',
                },
            ],
            postalCode: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.POSTALCODE.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.POSTALCODE.MESSAGE.MIN_LENGTH',
                    param: { minLength: 9 }
                },
                { type: 'pattern', message: 'FAVORITES.EDIT_FAVORITE.FORM.POSTALCODE.MESSAGE.PATTERN' }
            ],
            address: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.ADDRESS.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.ADDRESS.MESSAGE.MIN_LENGTH',
                    param: { minLength: 3 }
                },
                {
                    type: 'maxlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.ADDRESS.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
            ],
            numberAddress: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.NUMBER_ADDRESS.MESSAGE.REQUIRED' },
                {
                    type: 'maxlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.NUMBER_ADDRESS.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 5 }
                }
            ],
            complementAddress: [
                {
                    type: 'maxlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.COMPLEMENT_ADDRESS.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 30 },
                }
            ],
            neighborhood: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.NEIGHBORHOOD.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.NEIGHBORHOOD.MESSAGE.MIN_LENGTH',
                    param: { minLength: 3 }
                },
                {
                    type: 'maxlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.NEIGHBORHOOD.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
            ],
            cityAddress: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.CITY_ADDRESS.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.CITY_ADDRESS.MESSAGE.MIN_LENGTH',
                    param: { minLength: 3 }
                },
                {
                    type: 'maxlength',
                    message: 'FAVORITES.EDIT_FAVORITE.FORM.CITY_ADDRESS.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
            ],
            uf: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.UF.MESSAGE.REQUIRED' }
            ],
            country: [
                { type: 'required', message: 'FAVORITES.EDIT_FAVORITE.FORM.COUNTRY.MESSAGE.REQUIRED' },
            ],
        };
    }
    /**
     * Retorna todos os favoritos do usuario daquele WL
     * @param uuidWhiteLabel
     * @param uuidAccountPayment
     */
    getAllFavorites(uuidWhiteLabel, uuidAccountPayment) {
        return this.favoriteService.findAllFavorites(uuidWhiteLabel, uuidAccountPayment);
    }
    /**
   * Retorna todos os favoritos do usuario daquele WL filtrando por tipo
   * @param uuidWhiteLabel
   * @param uuidAccountPayment
   * @param type
   */
    getAllFavoritesType(uuidWhiteLabel, uuidAccountPayment, type) {
        return this.favoriteService.findAllFavoritesType(uuidWhiteLabel, uuidAccountPayment, type);
    }
    /**
     * Retorna apenas um favorito do usuario daquele WL
     * @param uuidWhiteLabel
     * @param uuidAccountPayment
     * @param id
     */
    getOneFavorite(uuidWhiteLabel, uuidAccountPayment, id) {
        return this.favoriteService.findOneFavorite(uuidWhiteLabel, uuidAccountPayment, id);
    }
    /**
     * Retorna todos os favoritos para o transferência (fluxo do APP)
     * @param uuidWhiteLabel
     * @param uuidAccountPayment
    */
    findFavoritesToTransfer(uuidWhiteLabel, uuidAccountPayment) {
        return this.favoriteService.findFavoritesToTransfer(uuidWhiteLabel, uuidAccountPayment);
    }
    realmValidation(realm) {
        let validate;
        switch (realm) {
            case 'PSXBANK':
                validate = true;
                break;
            default:
                validate = false;
                break;
        }
        return validate;
    }
    sortFavoritesListByName(array) {
        return array.sort((a, b) => {
            return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
        });
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    createFormFavoriteTransfer() {
        this.formFavorite = this.formBuilder.group({
            document: new FormControl('', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCPFCNPJ
            ])),
            name: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60)
            ])),
            accountType: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            bank: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            bankCode: new FormControl(''),
            branch: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(4)
            ])),
            accountNumber: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(15)
            ])),
        });
        return this.formFavorite;
    }
    createFormFavoritePix() {
        this.formFavorite = this.formBuilder.group({
            document: new FormControl('', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCPFCNPJ
            ])),
            name: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60)
            ])),
            accountType: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            bank: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            bankCode: new FormControl(''),
            branch: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(4)
            ])),
            accountNumber: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(15)
            ])),
            typeKey: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            pixKey: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.maxLength(100),
            ])),
        });
        return this.formFavorite;
    }
    createFormFavoriteCharging() {
        this.formFavorite = this.formBuilder.group({
            document: new FormControl('', Validators.compose([
                Validators.required,
                DocumentValidator.isValidCPFCNPJ
            ])),
            name: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60)
            ])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
            postalCode: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(9),
                Validators.pattern('^[a-zA-Z0-9_.+-]+$')
            ])),
            address: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(100),
            ])),
            numberAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(5),
            ])),
            complementAddress: new FormControl('', Validators.compose([
                Validators.maxLength(30),
            ])),
            neighborhood: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(100)
            ])),
            cityAddress: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(100)
            ])),
            uf: new FormControl('', Validators.compose([
                Validators.required
            ])),
            country: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(2),
            ])),
        });
        return this.formFavorite;
    }
    searchPostaCode(zipcode) {
        if (zipcode !== '' && zipcode !== null) {
            this.speNOpenAccountProxy
                .getCep(zipcode)
                .subscribe(data => this.updateAddress(data), error => this.errorMessageService.getError(error));
        }
    }
    updateAddress(address) {
        this.formFavorite.patchValue({
            address: address.logradouro,
            neighborhood: address.bairro,
            cityAddress: address.localidade,
            uf: address.uf,
            country: 'br'
        });
    }
    getUf() {
        return this.ufService.getListUf();
    }
    /**
     * Salva os dados de favorito
     * @param favorite
     */
    saveFavorite(favorite) {
        return this.favoriteService.saveFavorite(favorite);
    }
    /**
     * Atualiza os dados de favorito
     * @param favorite
     */
    updateFavorite(favorite) {
        return this.favoriteService.updateFavorite(favorite);
    }
    /**
     * Remove o de favorito da lista
     * @param favorite
     */
    deleteFavorite(favorite) {
        return this.favoriteService.deleteFavorite(favorite);
    }
};
AccountPaymentFavoriteService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        SpeNAccountFavoriteProxy,
        SpeNOpenAccountProxy,
        ErrorMessageService,
        UfService])
], AccountPaymentFavoriteService);

let UiBsAccountPaymentFavoriteModule = class UiBsAccountPaymentFavoriteModule {
};
UiBsAccountPaymentFavoriteModule = __decorate([
    NgModule({
        declarations: [],
        providers: [
            AccountPaymentFavoriteService
        ],
        imports: [
            UiPxAccountPaymentFavoriteModule
        ]
    })
], UiBsAccountPaymentFavoriteModule);

export { AccountPaymentFavoriteDTO, AccountPaymentFavoriteService, DeletedEnum, TypeEnum, UiBsAccountPaymentFavoriteModule };
//# sourceMappingURL=wlp-ui-bs-account-payment-favorite.js.map
